import { IonInput } from "@ionic/react";
import { useMaskito } from "@maskito/react";

type PhoneInputProps = {
  value: string;
  onIonInput: (value: string) => void;
};

export function PhoneInput(props: PhoneInputProps) {
  const { value, onIonInput } = props;

  const phoneMask = useMaskito({
    options: {
      mask: ["(", /\d/, /\d/, /\d/, ")", " ", /\d/, /\d/, /\d/, "-", /\d/, /\d/, /\d/, /\d/],
    },
  });

  return (
    // TODO: In the future we want to step away from using IonInput since it
    // shows a blue underline when typing in the input.
    <IonInput
      type="tel"
      aria-label="Contact Number Input"
      ref={async (phoneInput) => {
        if (phoneInput) {
          const input = await phoneInput.getInputElement();
          phoneMask(input);
        }
      }}
      value={value}
      onIonInput={(e) => onIonInput(e.detail.value ?? "")}
      placeholder="(XXX) XXX-XXXX"
    />
  );
}
